import { CaptureOptions } from 'posthog-js';
import { useCallback, useMemo } from 'react';

import { useAnalyticsContext } from './CoreAnalyticsProvider';

export const useAnalytics = (featurePrefix?: string) => {
  const analytics = useAnalyticsContext();

  const customCapture = useCallback(
    (
      eventName: string,
      properties?: Record<string, unknown>,
      captureOptions?: CaptureOptions,
    ) => {
      const finalEventName = featurePrefix
        ? `${featurePrefix}:${eventName}`
        : eventName;
      analytics.capture(finalEventName, properties, captureOptions);
    },
    [analytics, featurePrefix],
  );

  return useMemo(() => {
    return {
      capture: customCapture,
      isFeatureEnabled: analytics.isFeatureEnabled,
      getFeatureFlagPayload: analytics.getFeatureFlagPayload,
    };
  }, [analytics, customCapture]);
};
